import { ListItem, ListItemText, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';

interface SidebarItemProps {
  to: string;
  icon?: JSX.Element;
  label: React.ReactNode;
  type?: string;
  disabled?: boolean;
  end?: boolean;
  isHovered?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export default function SidebarItem({
  to,
  icon,
  label,
  type,
  disabled = false,
  end = false,
  isHovered = true,
  onClick
}: SidebarItemProps) {
  const theme = useTheme();
  return (
    <>
      {type !== 'mobile' ? (
        <ListItem
          sx={{
            py: 0,
            px: 1.5,
            display: 'block'
          }}
        >
          <NavLink
            to={disabled ? '#' : to}
            end={end}
            onClick={onClick}
            style={({ isActive }) => ({
              display: 'flex',
              justifyContent: isHovered ? 'flex-start' : 'center',
              alignItems: 'center',
              padding: isHovered ? '8px 12px' : '10px 8px',
              gap: isHovered ? '12px' : '0px',
              textDecoration: 'none',
              borderRadius: '4px',
              color: disabled ? '#aaa' : '#242424',
              backgroundColor: disabled ? 'transparent' : isActive ? theme.palette.primary.light : 'transparent',
              fontWeight: isActive ? 600 : 400,
              width: '100%',
              minHeight: isHovered ? 40 : undefined,
              boxSizing: 'border-box',
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            })}
          >
            <>
              <span
                style={{
                  display: 'inline-flex',
                  color: disabled ? '#aaa' : '#242424'
                }}
              >
                {icon}
              </span>
              {isHovered && (
                <ListItemText
                  primary={label}
                  sx={{
                    my: 0,
                    textWrap: 'nowrap',
                    '& .MuiListItemText-primary': {
                      fontSize: '16px',
                      lineHeight: 1.25,
                      color: disabled ? '#aaa' : '#242424'
                    }
                  }}
                />
              )}
            </>
          </NavLink>
        </ListItem>
      ) : (
        <ListItem className='mobile-sidebar'>
          <NavLink
            to={disabled ? '#' : to}
            end={end}
            onClick={onClick}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              padding: '2px 0px',
              gap: '4px',
              textDecoration: 'none',
              borderRadius: type === 'mobile' ? '5px' : '100px',
              color: disabled ? '#aaa' : isActive ? '#fff' : '#777777',
              backgroundColor: disabled ? '#E0E0E0' : isActive ? theme.palette.primary.main : '',
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            })}
          >
            {icon}
            <ListItemText primary={label} sx={{ textWrap: 'nowrap' }} />
          </NavLink>
        </ListItem>
      )}
    </>
  );
}
